import React from "react";
import MultiSelect from "../../../MultiSelect";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { SET_LOCK_FILTER } from "../reducers/common";
import { SET_SELECTED_LINE_UUIDS, RESET_FILTERS } from "../reducers/reducersFilters/filters";
import { translate } from "../../../IntlProviderWrapper";

import type { SetLockFilter } from "../reducers/common";
import type { LineOrders } from "../reducers/linesOrders";
import type { ReduxState } from "../reducers/reducers";
import type { SetRescheduleLineAction } from "../reducers/common";
import type { SetSelectedLineUuidsAction } from "../reducers/reducersFilters/filters";
import type { ResetFiltersAction } from "../reducers/reducersFilters/stockRequirementsFilters";

import img_lock_solid from "../../../../img/lock-solid.svg";
import img_unlock_solid from "../../../../img/unlock-solid.svg";

export const LOCKED_LINE_ID = "locked-line-icon";

// LockLine

type LockLineActionTypes = SetLockFilter;
type LockLineOwnProps = {};
type LockLineProps = LockLineOwnProps & LockLineReduxProps;

class LockLine extends React.Component<LockLineProps> {
    onClick = () => {
        this.props.reduxDispatch({
            type: SET_LOCK_FILTER,
            data: !this.props.is_filter_locked,
        });
    };

    render() {
        const img = this.props.is_filter_locked ? img_lock_solid : img_unlock_solid;
        return (
            <button
                className="btn-clean btn-opacity ml-2"
                id={LOCKED_LINE_ID}
                data-enabled={this.props.is_filter_locked}
                onClick={this.onClick}
            >
                <img src={img} width={20} height={20} />
            </button>
        );
    }
}

const lockLineMapState = (state: ReduxState) => ({
    is_filter_locked: state.gantt_chart_filters.is_filter_locked,
});
const lockLineMapDispatch = (dispatch: Dispatch<LockLineActionTypes>) => ({
    reduxDispatch: dispatch,
});
type LockLineReduxProps = ReturnType<typeof lockLineMapState> & ReturnType<typeof lockLineMapDispatch>;
export const ConnectedLockLine = connect<
    ReturnType<typeof lockLineMapState>,
    ReturnType<typeof lockLineMapDispatch>,
    LockLineOwnProps,
    ReduxState
>(
    lockLineMapState,
    lockLineMapDispatch
)(LockLine);

// ResetFilter

type ResetFilterActionTypes = ResetFiltersAction;
type ResetFilterOwnProps = {};
type ResetFilterProps = ResetFilterOwnProps & ResetFilterReduxProps;

class ResetFilter extends React.Component<ResetFilterProps> {
    onClick = () => {
        this.props.reduxDispatch({ type: RESET_FILTERS, data: undefined });
    };

    render() {
        return (
            <button
                className="btn btn-outline-danger flex-shrink-0 ml-2"
                style={{ fontWeight: 400 }}
                title={translate("common.reset_filters")}
                onClick={this.onClick}
            >
                <i className="fas fa-sync-alt align-middle mr-1" />
                <span className="ml-1">{translate("common.reset", "Reset")}</span>
            </button>
        );
    }
}

const resetFilterMapDispatch = (dispatch: Dispatch<ResetFilterActionTypes>) => ({
    reduxDispatch: dispatch,
});
type ResetFilterReduxProps = ReturnType<typeof resetFilterMapDispatch>;
export const ConnectedResetFilter = connect<
    {},
    ReturnType<typeof resetFilterMapDispatch>,
    ResetFilterOwnProps,
    ReduxState
>(
    null,
    resetFilterMapDispatch
)(ResetFilter);

type SelectOptionItem = {
    label: string;
    value: string;
};

// LineOrderListFilter

type ActionTypes = SetRescheduleLineAction | SetSelectedLineUuidsAction;
type OwnProps = { is_disabled?: string };
type Props = OwnProps & ReduxProps;

class LineOrderListFilter extends React.Component<Props> {
    getOptions = () => {
        return this.props.lines_orders.map(this.mapLineOrdersToOptions);
    };

    handleLineChange = (selected?: SelectOptionItem[]) => {
        if (!selected) {
            this.props.reduxDispatch({ type: SET_SELECTED_LINE_UUIDS, data: [] });
        } else {
            this.props.reduxDispatch({ type: SET_SELECTED_LINE_UUIDS, data: selected.map(s => s.value) });
        }
    };

    getSelectedLines = (): SelectOptionItem[] | undefined => {
        const options = this.props.lines_orders.map(this.mapLineOrdersToOptions);
        return options.filter(o => this.props.selected_line_uuids.includes(o.value)) || undefined;
    };

    mapLineOrdersToOptions = (line_orders: LineOrders) => {
        return {
            value: line_orders.line_uuid,
            label: line_orders.line_title,
        };
    };

    render() {
        const selected_lines = this.getSelectedLines();
        const options = this.getOptions();
        return (
            <div className="line-filter">
                <MultiSelect
                    key="line-filter"
                    value={selected_lines}
                    placeholder={translate("common.lines", "Lines")}
                    options={options}
                    onChange={this.handleLineChange}
                    isDisabled={this.props.is_disabled}
                    enable_filter_selected
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 100 }),
                        menu: base => ({ ...base, width: "max-content", minWidth: "100%" }),
                    }}
                />
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const lines_orders = state.gantt_chart_lines_orders.lines_orders;
    const selected_line_uuids = state.gantt_chart_filters.selected_line_uuids;

    return {
        lines_orders,
        selected_line_uuids,
    };
};
const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(LineOrderListFilter);
